<template>
  <b-container>
    <b-row>
      <b-col>
        <h1>Durchsuchen Sie das Archiv</h1>

        <p>Nutzen Sie die Schnellsuche für eine erste Stichwortsuche. Für genauere Abfragen nach Themen, Medien und
          Zeiträumen schalten Sie auf die Erweiterte Suche um.
          <router-link :to="{ name: 'searchhelp' }">[zur Hilfe]</router-link>
        </p>
      </b-col>
    </b-row>
    <b-row>
      <app-searchform></app-searchform>
    </b-row>
    <b-row>
      <b-col><h2 class="mt-4">Ihre Suchergebnisse</h2></b-col>
    </b-row>
    <app-searchresult></app-searchresult>
  </b-container>
</template>

<script>
import store from '@/store'
import SearchForm from '../components/SearchForm.vue'
import SearchResult from '../components/SearchResult.vue'

export default {
  components: {
    'app-searchform': SearchForm,
    'app-searchresult': SearchResult
  },
  created() {
    store.commit('setBreadcrumb', ['Medienarchiv'])
    store.commit('setActivePage', 'archive')
    store.commit('resetSearchFilter')
    store.dispatch('updateSearch')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ArchivePage.vue